import { Chip } from '@mui/material';

interface IAttributeSummary {
    attributeLabel: string
    labelValue?: string
    color: "primary" | "secondary"
    onClick: (e: any) => void
    onDelete?: () => void
}

let FilterSummary = (props: IAttributeSummary) => {

    return (
        <Chip
            label={props.attributeLabel + (props.labelValue ? ': ' : ' ') + (props.labelValue ? props.labelValue : '')}
            onDelete={props.onDelete}
            color={props.color}
            variant="outlined"
            onClick={props.onClick}
        />
    )
}

export default FilterSummary;